import { GroupDto } from "../../generated/api/models/GroupDto"

export const GET_GROUPS = 'GET_GROUPS'
export const SET_GROUPS = 'SET_GROUPS'
export const ADD_GROUP = 'ADD_GROUP'
export const DEL_GROUP = 'DEL_GROUP'
export const DEL_IDENTITY_CA = 'DEL_IDENTITY_CA'
export const GET_IDENTITY_CA = 'GET_IDENTITY_CA'
export const CHANGE_IDENTITY = 'CHANGE_IDENTITY'

export const getGroups = () => ({
    type: GET_GROUPS
})

export const addGroup = () => ({
    type: ADD_GROUP
})

export const deleteGroup = () => ({
    type: DEL_GROUP
})

export const deleteIdentityCa = () => ({
    type: DEL_IDENTITY_CA
})

export const getIdentityCa = () => ({
    type: GET_IDENTITY_CA
})

export const changeIdentity = () => ({
    type: CHANGE_IDENTITY
})

export const setGroups = (groups: GroupDto[]) => ({
    type: SET_GROUPS,
    groups
})

const initialState = {

}

export const keyStoreReducer = (state = initialState, action: any) => {

    const { groups } = action;

    switch (action.type) {
        case SET_GROUPS:
            return { ...state, groups: groups };
        default:
            return state
    }
}